















import {Vue, Component} from 'vue-property-decorator'
import {State} from 'vuex-class'

@Component({
  components: {},
})
export default class ThankYou extends Vue {
  @State((state) => state.configuration.appConfig.ios_store_url) public ios!: any
  @State((state) => state.configuration.appConfig.android_store_url) public android!: any

  private mounted() {
    // TODO: get back to home if registration is not finished
  }
}
